export default __webpack_public_path__ + "static/media/Hydrological_Modeling.8134d3d0.webp";